<template>
    <div class="w-full mx-4 payment">
        <div
            class="base-frame-white flex-row w-full px-2 lg:px-4 mt-6 form -mx-4"
        >
            <div class="w-full md:w-1/2 flex flex-col px-4">
                <div class="w-full">
                    <label class="form-label" for="">{{
                        "__JSON__.Naziv" | trans
                    }}</label>
                    <input
                        class="form-input"
                        type="text"
                        v-model="input.name"
                    />

                    <div v-if="errors.name" class="field-errors">
                        <span
                            v-for="err in errors.name"
                            :key="err"
                            v-text="err"
                            class="error-help"
                        ></span>
                    </div>
                </div>
                <div class="w-full mt-3">
                    <label class="form-label" for="">{{
                        "__JSON__.OIB" | trans
                    }}</label>
                    <input class="form-input" type="text" v-model="input.oib" />

                    <div v-if="errors.oib" class="field-errors">
                        <span
                            v-for="err in errors.oib"
                            :key="err"
                            v-text="err"
                            class="error-help"
                        ></span>
                    </div>
                </div>
            </div>
            <div class="w-full md:w-1/2 mt-4 md:mt-0 flex flex-wrap px-4">
                <div class="w-full flex -mx-2">
                    <div class="w-1/2 px-2">
                        <label class="form-label" for="">{{
                            "__JSON__.Proračunska godina" | trans
                        }}</label>
                        <select class="form-input" v-model="input.year">
                            <option value="" disabled selected>
                                {{ "Odaberite godinu" | trans }}
                            </option>
                            <option
                                v-for="year in years"
                                :key="year"
                                :value="year"
                            >
                                {{ year }}
                            </option>
                        </select>

                        <div v-if="errors.year" class="field-errors">
                            <span
                                v-for="err in errors.year"
                                :key="err"
                                v-text="err"
                                class="error-help"
                            ></span>
                        </div>
                    </div>
                    <div class="w-1/2 px-2">
                        <label class="form-label" for="">{{
                            "__JSON__.Mjesec" | trans
                        }}</label>
                        <select class="form-input" v-model="input.month">
                            <option value="" disabled selected>
                                {{ "__JSON__.Odaberite mjesec" | trans }}
                            </option>
                            <option :value="1">1</option>
                            <option :value="2">2</option>
                            <option :value="3">3</option>
                            <option :value="4">4</option>
                            <option :value="5">5</option>
                            <option :value="6">6</option>
                            <option :value="7">7</option>
                            <option :value="8">8</option>
                            <option :value="9">9</option>
                            <option :value="10">10</option>
                            <option :value="11">11</option>
                            <option :value="12">12</option>
                        </select>

                        <div v-if="errors.month" class="field-errors">
                            <span
                                v-for="err in errors.month"
                                :key="err"
                                v-text="err"
                                class="error-help"
                            ></span>
                        </div>
                    </div>
                </div>

                <div class="w-full mt-9">
                    <button type="button" @click="search" class="btn-search">
                        <span v-if="loading">{{
                            "__JSON__.Tražimo..." | trans
                        }}</span
                        ><span v-else>{{ "__JSON__.Traži" | trans }}</span>
                    </button>
                </div>
            </div>
        </div>

        <div v-if="result !== null && !loading" class="mt-5 w-full -mx-4">
            <h2 class="big-title-half">
                {{ "__JSON__.Rezultati pretrage" | trans }}
            </h2>

            <div v-if="result === false">
                <span class="font-bold">{{
                    "__JSON__.Nema podataka za primatelja. Pretragu pravnih osoba pokušati preko OIB-a."
                        | trans
                }}</span>
            </div>
            <div v-else-if="result">
                <span class="font-bold"
                    >{{ "__JSON__.Razdoblje" | trans }}: {{ result.month }}/{{
                        result.year
                    }}.</span
                >

                <div class="overflow-x-scroll xl:overflow-visible">
                    <table
                        class="table-toll-info pl-0 w-full service-info mt-5"
                    >
                        <colgroup>
                            <col style="width: 35%" />
                            <col style="width: 15%" />
                            <col style="width: 20%" />
                            <col style="width: 30%" />
                        </colgroup>
                        <tr>
                            <td>{{ "__JSON__.Primatelj" | trans }}</td>
                            <td>{{ "__JSON__.OIB" | trans }}</td>
                            <td>{{ "__JSON__.Sjedište" | trans }}</td>
                            <td>
                                {{
                                    "__JSON__.Iznos za odabrano razdoblje"
                                        | trans
                                }}
                            </td>
                        </tr>

                        <tr>
                            <td>{{ result.recipient_name }}</td>
                            <td>{{ result.pin }}</td>
                            <td>{{ result.headquarters }}</td>
                            <td class="text-right">{{ result.amount }}</td>
                        </tr>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import pickBy from "lodash/pickBy";

export default {
    name: "PaymentSearch",

    props: {
        years: {
            required: true,
            type: Array,
            default: () => [],
        },
    },

    data() {
        return {
            loading: false,
            result: null,
            input: {
                name: null,
                oib: null,
                month: null,
                year: null,
            },
            errors: {},
        };
    },

    methods: {
        search() {
            this.result = null;
            this.errors = {};
            this.loading = true;

            const formInput = pickBy(this.input, function (item) {
                return item;
            });

            axios
                .post(route("payments.search"), formInput, {
                    headers: {
                        Accept: "application/json",
                    },
                })
                .then((response) => {
                    this.result = response.data;
                    this.loading = false;
                })
                .catch((err) => {
                    this.loading = false;

                    if (err.response.status === 404) {
                        this.result = false;
                    }

                    if (err.response.status === 422) {
                        console.log(err.response);
                        this.errors = err.response.data.errors;
                    }
                });

            console.log("do search");
        },
    },
};
</script>
